export default[
    {
        path: '/presupuestos',
        component: () => import(/* webpackChunkName: "presupuestos" */ '@/views/Presupuestos.vue'),
        meta: {
            requiresAuth: true,
            roles:['ROLE_LABORATORIO'],
        },
        children:[
            {
                path:'/',
                name:'presupuestosList',
                component: () => import(/* webpackChunkName: "presupuestosList" */ '@/views/presupuestos/Laboratorio.vue'),
                meta: {
                    requiresAuth: true,
                    roles:['ROLE_LABORATORIO'],
                },
            },
            {
                path:'imagen',
                name:'presupuestosImagen',
                component: () => import(/* webpackChunkName: "presupuestosImagen" */ '@/views/presupuestos/Imagen.vue'),
                meta: {
                    requiresAuth: true,
                    roles:['ROLE_LABORATORIO'],
                },
            },
            {
                path:'laboratorio',
                name:'presupuestosLaboratorio',
                component: () => import(/* webpackChunkName: "presupuestosLaboratorio" */ '@/views/presupuestos/Laboratorio.vue'),
                meta: {
                    requiresAuth: true,
                    roles:['ROLE_LABORATORIO'],
                },
            },
        ]
    }
]